import { React, useRef, useState, useEffect, useLayoutEffect } from "react";
import Header from "./Header";
import Footer2 from "./Footer2";
import HeaderLower from "./HeaderLower";
import "./style.css";
import "./Input_fields.css";
import "bootstrap/dist/css/bootstrap.min.css";
import secureLocalStorage from "react-secure-storage";
import swal from "sweetalert";

import RegisterService from "../services/register.service";
import LogService from "../services/log.service";
import StorageService from "../services/storage.service";
import { Navigate, Redirect, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import Select from "react-select";
import Footer from "./Footer";

// import PreLoader from "./PreLoader";
function RegisterForm(props) {
  const TITLE = "Ashley TestRest NW | Registration Form";
  const [fields, setFields] = useState({
    name: "",
    lname: "",
    emailid: "",
    sales_name: "",
    store_location: "",
  });

  // const options = [
  //   { label: "Customer", value: "Customer" },
  //   { label: "Country", value: "Country" },
  //   { label: "Prefecture", value: "Prefecture" },
  //   { label: "Site", value: "Site" }
  // ];

  // const [permissionFor, setPermissionFor] = useState({
  //   label: "Customer",
  //   value: "Customer"
  // });
  // const handleSelectChange = (newValue, meta) => {
  //   if (newValue) {
  //     const label = meta.name;
  //     switch (label) {
  //       case "permissionFor":
  //         setPermissionFor(newValue);
  //         break;
  //       default:
  //         break;
  //     }
  //   }
  // };

  // const [states, setStates] = useState([]);
  const [saleError, setSaleError] = useState("");
  const [disablility, setDisablility] = useState(true);
  const [emplyId, setEmplyId] = useState([]);
  const [storeId, setStoreId] = useState([]);
  const [errors, setErrors] = useState({});

  // const [signoutTime, setSignoutTime] = useState(180000);
  const [signoutTime, setSignoutTime] = useState(900000);
  const [value_userform, setValue_userform] = useState([]);
  const [website, setWebsite] = useState(window.location.href);
  const navigate = useNavigate();

  secureLocalStorage.removeItem("registerform");

  useLayoutEffect(() => {
    const destroy = () => {
      localStorage.clear();
    };
    destroy();
  }, []);

  useEffect(() => {
    async function logCreate() {
      try {
        await LogService.createLog(website);
      } catch (e) {
        console.log(e);
      }
    }
    logCreate();
  }, [website]);

  timeout();
  function timeout() {
    setTimeout(function () {
      logout();
    }, signoutTime);
  }

  const logout = () => {
    destroy();
  };

  const destroy = () => {
    localStorage.setItem("returnpage", true);
    localStorage.removeItem("return_page", false);
    localStorage.removeItem("registerForm");
    window.location.replace("/");
  };

  // StorageService.setRegister(false);
  localStorage.setItem("isRegister", true);

  const ref = useRef();
  useEffect(() => {
    // async function test() {
    //   let errors = {};

    //   try {
    //     //FIXME remove this service if not used
    //     const response = await RegisterService.getStates();
    //     var value = response.data.data;
    //     this.setStates({
    //       value: value,
    //     });
    //     if (response.data.status === 429 || response.data.status === "429") {
    //       alert("Max Limit Reached. Please wait.");
    //     }
    //     if (value.includes("redirect")) {
    //     } else {
    //       errors["questionnare"] = response.data.response;
    //     }
    //   } catch (err) {
    //     if (err.status === 429 || err.status === "429") {
    //       alert("Max Limit Reached. Please wait.");
    //     }
    //   }
    // }

    async function getEmployee() {
      let errors = {};

      try {
        //FIXME remove this service if not used
        const response = await RegisterService.getEmployees();
        let value = response.data.data;
        // options.push({label: "1", value: "2"});
        // console.log(value);
        setEmplyId(value);
        if (response.data.status === 429 || response.data.status === "429") {
          alert("Max Limit Reached. Please wait.");
        }
        if (value.includes("redirect")) {
        } else {
          errors["questionnare"] = response.data.response;
        }
      } catch (err) {
        if (err.status === 429 || err.status === "429") {
          alert("Max Limit Reached. Please wait.");
        }
      }
    }
    async function getStoreLocation() {
      let errors = {};

      try {
        //FIXME remove this service if not used
        const response = await RegisterService.getStoreLocation();
        let value = response.data.data;
        // console.log(value);
        // options.push({label: "1", value: "2"});
        // console.log(value);
        setStoreId(value);
        if (response.data.status === 429 || response.data.status === "429") {
          alert("Max Limit Reached. Please wait.");
        }
        if (value.includes("redirect")) {
        } else {
          errors["questionnare"] = response.data.response;
        }
      } catch (err) {
        if (err.status === 429 || err.status === "429") {
          alert("Max Limit Reached. Please wait.");
        }
      }
    }
    // test();
    // getEmployee();
    getStoreLocation();
  }, []);

  // async function checkEmployee(store, emp) {
  //   try {
  //     setSaleError("");
  //     const response = await RegisterService.checkEmployee(store, emp);

  //     if (response.data.status === 429 || response.data.status === "429") {
  //       alert("Max Limit Reached. Please wait.");
  //     }

  //     setSaleError(response.data.message.sales_name);
  //     // console.log(errors.sales_name);
  //   } catch (err) {
  //     if (err.status === 429 || err.status === "429") {
  //       alert("Max Limit Reached. Please wait.");
  //     }
  //   }
  // }

  async function getEmployee(store) {
    let errors = {};

    try {
      setEmplyId([]);
      //FIXME remove this service if not used
      const response = await RegisterService.getEmployees(store);
      let value = response.data.data;
      // options.push({label: "1", value: "2"});
      // console.log(value);
      setEmplyId(value);
      if (response.data.status === 429 || response.data.status === "429") {
        alert("Max Limit Reached. Please wait.");
      }
      if (value.includes("redirect")) {
      } else {
        errors["questionnare"] = response.data.response;
      }
    } catch (err) {
      setEmplyId([]);

      if (err.status === 429 || err.status === "429") {
        alert("Max Limit Reached. Please wait.");
      }
    }
  }

  const pasted = (e) => {
    e.preventDefault();
    return false;
  };

  const onlyNumbers = (evt) => {
    const { name, value } = evt.target;
    evt.target.value = evt.target.value.replace(/[^0-9]+/g, "");

    setFields((prevValue) => {
      return {
        ...prevValue,
        [name]: evt.target.value,
      };
    });
  };

  const handleChange = (e) => {
    setSaleError("");
    let { value, name } = e.target;
    if (name === "store_location" && value === "true") {
      value = "";
    }

    if (name === "store_location") {
      fields.sales_name = "";

      if (value != "") {
        getEmployee(value);
      } else {
        setEmplyId([]);
      }
    }

    setFields((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });
  };
  const saveErrors = (err) => {
    setErrors(err);
  };

  const submituserRegistrationForm = (e) => {
    e.preventDefault();
    let data = {
      fname: fields?.name,
      lname: fields?.lname,
      email: fields?.emailid,
      sales_name: fields?.sales_name,
      store_location: fields?.store_location,
    };
    console.log(data);
    try {
      try {
        LogService.createFormLog(website, "POST", data);
      } catch (e) {
        console.log(e);
      }

      const responseuserform = RegisterService.regData(data);
      responseuserform
        .then((response) => {
          LogService.apiResLog(website, JSON.stringify(response.data));

          var valueUserform = response?.data?.status;
          setValue_userform(valueUserform);

          // StorageService.setRegister(true);
          localStorage.removeItem("return_page");

          swal({
            title: "Successful!",
            text: "Form Submitted!",
            type: "success",
            icon: "success",
          }).then(() => {
            secureLocalStorage.setItem(
              "registerform",
              JSON.stringify({
                name: fields.name,
                lname: fields.lname,
                emailid: fields.emailid,
                sales_name: fields.sales_name,
                store_location: fields.store_location,
              })
            );
            navigate("/register/registration-thankyou");
          });
          if (value_userform?.includes("redirect")) {
          }
        })
        .catch((err) => {
          if (
            err?.response?.data?.message &&
            typeof err?.response?.data?.message === "string"
          ) {
            swal({
              title: "Error!",
              text: err?.response?.data?.message,
              type: "error",
              icon: "error",
            });
          }
          LogService.apiResLog(website, JSON.stringify(err.response.data));

          let errorData = {};
          errorData["name"] =
            err?.response?.data?.message &&
            err?.response?.data?.message.fname &&
            err?.response?.data?.message.fname[0];
          errorData["lname"] =
            err?.response?.data?.message &&
            err?.response?.data?.message.lname &&
            err?.response?.data?.message.lname[0];
          errorData["emailid"] =
            err?.response?.data?.message &&
            err?.response?.data?.message.email &&
            err?.response?.data?.message.email[0];
          errorData["sales_name"] =
            err?.response?.data?.message &&
            err?.response?.data?.message.sales_name &&
            err?.response?.data?.message.sales_name[0];
          errorData["store_location"] =
            err?.response?.data?.message &&
            err?.response?.data?.message.store_location &&
            err?.response?.data?.message.store_location[0];
          errorData["checkederrorcaptcha"] =
            err?.response?.data?.message &&
            err?.response?.data?.message.captcha &&
            err?.response?.data?.message.captcha[0];
          errorData["checkederrortwo"] =
            err?.response?.data?.message &&
            err?.response?.data?.message.size &&
            err?.response?.data?.message.size[0];
          saveErrors(errorData);
          ref?.current?.focus();
        });
    } catch (err) {
      alert(err);
      if (err.response.status === 429 || err.response.status === "429") {
        alert("Max Limit Reached. Please wait.");
      }
      let errorData = {};
      errorData["name"] = err?.response?.data?.message.fname[0];
      errorData["lname"] = err?.response?.data?.message.lname[0];
      errorData["emailid"] = err?.response?.data?.message.emailid[0];
      errorData["store_location"] =
        err?.response?.data?.message.store_location[0];
      errorData["sales_name"] = err?.response?.data?.message.sales_name[0];
      errorData["checkederrorcaptcha"] =
        err?.response?.data?.message.captcha[0];
      saveErrors(errorData);
    }
  };
  const validate = (e) => {
    let errors = {};
    let isformIsValid = true;

    return isformIsValid;
  };

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div className="container-fluid">
        {/* <PreLoader/> */}
        <Header />
        <HeaderLower />
        <div id="main-registration-container">
          <div className="white-box form" id="font-style">
            <h1>Register to score your free Reward Card!</h1>
            {/* <h1>Register to score your free Reward Card!</h1> */}
            <hr />
            <form
              name="userRegistrationForm"
              className="form-outer"
              onSubmit={submituserRegistrationForm}
              // onClick={this.popup}
            >
              <div className="row">
                <div className="col-md-6">
                  <label className="formsub">
                    First Name <span className="red_point">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="First Name"
                    style={errors.name ? { border: "1px solid red" } : null}
                    name="name"
                    // tabIndex="1"
                    id="fname"
                    className="searchBox_deals vc-validate"
                    ref={errors.name ? ref : null}
                    value={fields.name || ""}
                    autoFocus=""
                    onChange={handleChange}
                  />
                  <div className="errorMsg">{errors.name}</div>
                </div>
                <div className="col-md-6">
                  <label className="formsub">
                    Last Name <span className="red_point">*</span>
                  </label>
                  <input
                    type="text"
                    name="lname"
                    style={
                      errors.lname && !errors.name
                        ? { border: "1px solid red" }
                        : null
                    }
                    placeholder="Last Name"
                    // tabIndex="1"
                    id="lname"
                    className="searchBox_deals vc-validate"
                    value={fields.lname || ""}
                    autoFocus=""
                    ref={errors.lname && !errors.name ? ref : null}
                    onChange={handleChange}
                  />
                  <div className="errorMsg">
                    {errors.lname && !errors.name ? errors.lname : null}
                  </div>
                </div>
                <div className="col-md-6">
                  <label className="formsub">
                    Email <span className="red_point">*</span>
                  </label>
                  <input
                    type="text"
                    name="emailid"
                    // tabIndex="10"
                    ref={
                      errors.emailid && !errors.lname && !errors.name
                        ? ref
                        : null
                    }
                    style={
                      errors.emailid && !errors.lname && !errors.name
                        ? { border: "1px solid red" }
                        : null
                    }
                    id="emailid"
                    placeholder="E-mail"
                    value={fields.emailid || ""}
                    autoFocus=""
                    onChange={handleChange}
                  />
                  <div className="errorMsg">
                    {errors.emailid && !errors.lname && !errors.name
                      ? errors.emailid
                      : null}
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="formsub">
                    Store Location <span className="red_point">*</span>
                  </label>
                  <select
                    style={
                      errors.store_location &&
                      !errors.emailid &&
                      !errors.lname &&
                      !errors.name
                        ? { border: "1px solid red", color: "black" }
                        : { color: "black" }
                    }
                    ref={
                      errors.store_location &&
                      !errors.emailid &&
                      !errors.lname &&
                      !errors.name
                        ? ref
                        : null
                    }
                    name="store_location"
                    id="store_location"
                    // tabIndex="5"
                    className="select_1 dropdown"
                    onChange={handleChange}
                  >
                    <option value>Select Store Locations</option>
                    {storeId.map((option) => {
                      return (
                        <>
                          <option value={option.id}>
                            {option.store_location}
                          </option>
                        </>
                      );
                    })}

                    {/* <>
                   <option value>Select Store Location</option>
                    <option value="Burbank CA"> Burbank CA</option>
                    <option value="Bakersfield CA"> Bakersfield CA</option>
                    <option value="Colma CA"> Colma CA</option>
                    <option value="Canoga Park CA"> Canoga Park CA</option>
                    <option value="Colton CA"> Colton CA</option>
                    <option value="Concord CA"> Concord CA</option>
                    <option value="Dublin CA"> Dublin CA</option>
                    <option value="El Cajon CA"> El Cajon CA</option>
                    <option value="Emeryville CA"> Emeryville CA</option>
                    <option value="Fairfield CA"> Fairfield CA</option>
                    <option value="Fremont CA"> Fremont CA</option>
                    <option value="Fresno CA"> Fresno CA</option>
                    <option value="Folsom CA"> Folsom CA</option>
                    <option value="Hawthorne CA">Hawthorne CA</option>
                    <option value="Huntington Beach CA">
                      Huntington Beach CA
                    </option>
                    <option value="Laguna Hills CA"> Laguna Hills CA</option>
                    <option value="Lathrop CA"> Lathrop CA</option>
                    <option value="Long Beach CA"> Long Beach CA</option>
                    <option value="Los Angeles (S Broadway) CA">
                      Los Angeles (S Broadway) CA{" "}
                    </option>
                    <option value="Los Angeles (West LA) CA">
                      {" "}
                      Los Angeles (West LA) CA
                    </option>
                    <option value="Murrieta CA"> Murrieta CA</option>
                    <option value="Modesto CA"> Modesto CA</option>
                    <option value="Montclair CA"> Montclair CA</option>
                    <option value="Merced CA"> Merced CA</option>
                    <option value="Northridge CA"> Northridge CA</option>
                    <option value="Oxnard CA"> Oxnard CA</option>
                    <option value="Palm Desert CA"> Palm Desert CA</option>
                    <option value="Palmdale CA"> Palmdale CA</option>
                    <option value="Rohnert Park CA"> Rohnert Park CA</option>
                    <option value="Roseville CA"> Roseville CA</option>
                    <option value="Redding CA"> Redding CA</option>
                    <option value="Reno NV"> Reno NV</option>
                    <option value="Santa Ana CA">Santa Ana CA</option>
                    <option value="Santa Clarita CA"> Santa Clarita CA</option>
                    <option value="Sacramento CA"> Sacramento CA</option>
                    <option value="San Diego CA"> San Diego CA</option>
                    <option value="San Marcos CA"> San Marcos CA</option>
                    <option value="San Jose CA"> San Jose CA</option>
                    <option value="Stockton CA"> Stockton CA</option>
                    <option value="Torrance CA">Torrance CA</option>
                    <option value="Visalia CA"> Visalia CA</option>
                    <option value="Victorville CA"> Victorville CA</option>
                    <option value="West Covina CA"> West Covina CA</option>
                    <option value="Yorba Linda CA"> Yorba Linda CA</option>
                    </> */}
                  </select>
                  <div className="errorMsg">
                    {errors.store_location &&
                    !errors.emailid &&
                    !errors.lname &&
                    !errors.name
                      ? errors.store_location
                      : null}
                  </div>
                </div>

                {/* <div className="col-md-6">
                  <label className="formsub">
                    Employee ID # <span className="red_point">*</span>
                  </label>
                  <input
                    type="text"
                    id="sales_name"
                    disabled={disablility}
                    style={
                      errors.sales_name &&
                      !errors.store_location &&
                      !errors.emailid &&
                      !errors.lname &&
                      !errors.name
                        ? { border: "1px solid red" }
                        : null
                    }
                    name="sales_name"
                    placeholder="Employee ID"
                    value={fields.sales_name || ""}
                    autoFocus=""
                    ref={
                      errors.sales_name &&
                      !errors.store_location &&
                      !errors.emailid &&
                      !errors.lname &&
                      !errors.name
                        ? ref
                        : null
                    }
                    onChange={handleChange}
                    onKeyUp={onlyNumbers}
                    onPaste={pasted}
                  />
                  <div className="errorMsg">
                    {errors.sales_name &&
                    !errors.store_location &&
                    !errors.emailid &&
                    !errors.lname &&
                    !errors.name
                      ? errors.sales_name
                      : null}
                  </div>
                  {saleError && <div className="errorMsg">{saleError}</div>}
                </div> */}

                {/* TODO Search + Select Field */}
                {/* <div className="col-md-6">
                  <label className="formsub">
                  Employee ID # <span className="red_point">*</span>
                  </label>
                  <Select
                      style={
                      errors.sales_name &&
                      !errors.emailid &&
                      !errors.lname &&
                      !errors.name
                        ? { border: "1px solid red", color: "black" }
                        : { color: "black" }
                    }
                    ref={
                      errors.sales_name &&
                      !errors.emailid &&
                      !errors.lname &&
                      !errors.name
                        ? ref
                        : null
                    }
                  options={options}
                  onChange={handleSelectChange}
                  name="sales_name"
                  id="sales_name"
                  value={permissionFor}
                  placeholder="Choose a Customer"
                  className="customer-search-select"
                />

                </div> */}

                {/* TODO Slect employee_id */}
                <div className="col-md-6">
                  <label className="formsub">
                    Employee ID # <span className="red_point">*</span>
                  </label>
                  <select
                    style={
                      errors.sales_name &&
                      !errors.store_location &&
                      !errors.emailid &&
                      !errors.lname &&
                      !errors.name
                        ? { border: "1px solid red", color: "black" }
                        : { color: "black" }
                    }
                    ref={
                      errors.sales_name &&
                      !errors.store_location &&
                      !errors.emailid &&
                      !errors.lname &&
                      !errors.name
                        ? ref
                        : null
                    }
                    name="sales_name"
                    id="sales_name"
                    className="select_1 dropdown"
                    onChange={handleChange}
                  >
                    <option value="">Select Employee ID</option>
                    {emplyId.map((option) => {
                      return (
                        <>
                          <option
                            key={option.employee_id}
                            value={option.employee_id}
                          >
                            {`${option.employee_id} - ${option.fname} ${option.lname}`}
                          </option>
                        </>
                      );
                    })}
                  </select>
                  <div className="errorMsg">
                    {errors.sales_name &&
                    !errors.store_location &&
                    !errors.emailid &&
                    !errors.lname &&
                    !errors.name
                      ? errors.sales_name
                      : null}
                  </div>
                </div>

                <br />
                <br />

                <div className="clearfix"></div>
              </div>

              <div className="alert alert-info">
                Limit 1 per household, while supplies last. Some restrictions
                apply, see store for detail.
              </div>
              <input
                onClick="myTimeout()"
                type="submit"
                name="submit"
                id="submit"
                value="SUBMIT"
                className="sub-btn2 button Formfirst"
              />
            </form>
          </div>
        </div>
      </div>
      {/* <Footer2 /> */}
      <Footer />
    </>
  );
}
export default RegisterForm;
